module.exports = __webpack_public_path__ + "static/media/tui@3x.53067d72.png";